import React from 'react';

const GroupsTab = ({ filters }) => {
  const tableData = [
    { zdo: 234, district: 'Шевченківський', group: 1, totalPlaces: 12, plannedPlaces: 15, children: 9, kyiv: 3, reserve: 3, free: 0, specialization: 'Загальний недогоп...', accounting: 3, v: 4 },
    // ... остальные данные
  ];

  return (
    <div className="publicstatistic-statistics-table-section">
      <h3 className="publicstatistic-section-title">
        Інформація про групи станом на {filters.asOf}
      </h3>

      <div className="publicstatistic-table-responsive">
        <table className="table publicstatistic-statistics-table">
          <thead>
            <tr>
              <th>ЗДО</th>
              <th>Район</th>
              <th>Група</th>
              <th>Місць (заг...)</th>
              <th>Місць (пл...)</th>
              <th>Дітей</th>
              <th>Київ</th>
              <th>Резерву</th>
              <th>Вільних</th>
              <th>Спеціалізація</th>
              <th>Рахування</th>
              <th>В</th>
            </tr>
          </thead>
          <tbody>
            {tableData.map((row, index) => (
              <tr key={index}>
                <td className="publicstatistic-district-name">{row.zdo}</td>
                <td>{row.district}</td>
                <td>{row.group}</td>
                <td>{row.totalPlaces}</td>
                <td>{row.plannedPlaces}</td>
                <td>{row.children}</td>
                <td>{row.kyiv}</td>
                <td>{row.reserve}</td>
                <td>{row.free}</td>
                <td>{row.specialization}</td>
                <td>{row.accounting}</td>
                <td>{row.v}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default GroupsTab;